import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import 'cirrus-ui';
import './style.scss';

createApp(App).use(router).mount('#app');
